import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { ViewColumnComponent } from '../../../../../view-column.component';
import { SubSink } from 'subsink2';
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
import { BranchSettingsActions } from '../../../branch-settings-controller/actions';

interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  selectedIndex: number;
  deleteConfirmation: boolean;
}

@Component({
  selector: 'app-util-branch-pricing-schme-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})

export class UtilBranchPricingSchemeEditComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Edit Pricing Scheme';
  protected index = 3;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);


  branchGuid;
  form: FormGroup;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;
  selectedPricingScheme;
  constructor(
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      console.log('state',a);
      this.localState = a;
      this.selectedPricingScheme = a?.data;
      this.componentStore.setState(a);
    });
    this.form = new FormGroup({
      pricingScheme: new FormControl(),
      level: new FormControl()
    })

    this.form.patchValue({
       pricingScheme: this.selectedPricingScheme.bl_fi_mst_branch_pricing_scheme_hdr_link.guid_pricing_scheme_hdr,
       level: this.selectedPricingScheme.bl_fi_mst_branch_pricing_scheme_hdr_link.level_value
    });


  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }

  onSave(){
    this.selectedPricingScheme.bl_fi_mst_branch_pricing_scheme_hdr_link.level_value = this.form.value.level;
    this.selectedPricingScheme.bl_fi_mst_branch_pricing_scheme_hdr_link.guid_pricing_scheme_hdr = this.form.value.pricingScheme;
    this.branchSettingsStore.dispatch(BranchSettingsActions.editBranchPricingSchemeInit({container:this.selectedPricingScheme}));
    this.onReturn();
  }

  onDelete() {
    this.branchSettingsStore.dispatch(BranchSettingsActions.deleteBranchPricingSchemeInit({guid: this.selectedPricingScheme.bl_fi_mst_branch_pricing_scheme_hdr_link.guid.toString()}));
    this.onReturn();
  }


}
